var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 635,
    height: 768,
    viewBox: "0 0 635 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Log_in_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 635,
    height: 768
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log_in_2",
    "data-name": "Log in \\u2013 2",
    clipPath: "url(#clip-Log_in_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 635,
    height: 768,
    fill: "#e4f7f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grameen-logo",
    transform: "translate(119.727 348.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(86.928 14.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M89.58,25.7h5.41V36.324a20.458,20.458,0,0,1-11.213,3.594c-8.37,0-14.727-6.081-14.727-14.1,0-7.976,6.473-14.017,15.082-14.017a17.416,17.416,0,0,1,11.095,4.029l-3.514,4.461a11.568,11.568,0,0,0-7.581-3.08,8.628,8.628,0,1,0,.039,17.255,12.575,12.575,0,0,0,5.41-1.5Z",
    transform: "translate(-69.05 -11.804)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M102.2,26.491h5.765c3.433,0,5.407-1.579,5.407-4.737,0-3.081-1.974-4.62-5.407-4.62H102.2ZM112.934,39.6l-4.384-7.9H102.2v7.9H95.959V11.961h12c7.223,0,11.331,3.475,11.331,9.595,0,4.264-1.818,7.343-5.174,8.922L120,39.6Z",
    transform: "translate(-62.083 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M137.453,29.215l-4.344-10.74-4.382,10.74Zm2.012,5.015H126.675L124.5,39.6h-6.435l12-27.639H136.5L148.31,39.6h-6.674Z",
    transform: "translate(-56.358 -11.764)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M152.9,11.962l8.055,16.9,8.013-16.9h6.95V39.6h-5.606V20.964L162.97,36.8H158.9l-7.343-15.832V39.6h-5.645V11.962Z",
    transform: "translate(-49.148 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M197.16,11.962v5.172H182.351v6H195.66v5.172H182.351v6.121h15.242V39.6H176.116V11.962Z",
    transform: "translate(-41.329 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M220.46,11.962v5.172H205.653v6H218.96v5.172H205.653v6.121h15.241V39.6H199.416V11.962Z",
    transform: "translate(-35.296 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M227.714,11.962l13.425,17.767V11.962h5.921V39.6h-5.686L227.99,21.873V39.6h-5.961V11.962Z",
    transform: "translate(-29.441 -11.763)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M83.207,40.273l-.022,2.381H75.3v4.534h7.14v2.357H75.3v6.444H72.657V40.273Z",
    transform: "translate(-68.116 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M89.749,48.144a5.635,5.635,0,0,0,5.658,5.591,5.569,5.569,0,1,0-5.658-5.591m13.964,0a8.339,8.339,0,1,1-8.33-7.926,8.042,8.042,0,0,1,8.33,7.926",
    transform: "translate(-64.388 -4.447)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M114.2,53.72a3.87,3.87,0,0,0,4.152-4.244v-9.2h2.651v9.2c0,4.109-2.581,6.623-6.825,6.623s-6.848-2.514-6.848-6.623v-9.2h2.649v9.2a3.922,3.922,0,0,0,4.22,4.244",
    transform: "translate(-59.137 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M129.737,40.273l8.419,11.294V40.273h2.6V55.988h-2.6l-8.376-11.27v11.27h-2.648V40.273Z",
    transform: "translate(-54.012 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M159.416,48.153a5.357,5.357,0,0,0-5.5-5.5h-3.75V53.607h3.861a5.267,5.267,0,0,0,5.388-5.455m2.673-.022c0,4.534-3.436,7.856-8.2,7.856h-6.375V40.273h6.442c4.716,0,8.129,3.3,8.129,7.857",
    transform: "translate(-48.733 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M175.552,50.082,172.59,43.1l-2.964,6.981Zm1.01,2.358h-7.924l-1.5,3.546h-2.761l6.938-15.715h2.715L180.9,55.987h-2.832Z",
    transform: "translate(-44.369 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M194.183,40.273v2.381H189.2V55.988H186.55V42.654h-4.96V40.273Z",
    transform: "translate(-39.911 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M199.532,55.988h2.649V40.273h-2.649Z",
    transform: "translate(-35.266 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M212.868,48.144a5.636,5.636,0,0,0,5.658,5.591,5.569,5.569,0,1,0-5.658-5.591m13.964,0a8.339,8.339,0,1,1-8.328-7.926,8.042,8.042,0,0,1,8.328,7.926",
    transform: "translate(-32.511 -4.447)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M233.128,40.273l8.419,11.294V40.273h2.6V55.988h-2.6l-8.374-11.27v11.27h-2.649V40.273Z",
    transform: "translate(-27.242 -4.433)",
    fill: "#007b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M63.927,29.781A35.86,35.86,0,0,0,29.781,63.928,35.861,35.861,0,0,0,63.927,29.781",
    transform: "translate(7.711 7.711)",
    fill: "#689431",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,29.781A35.861,35.861,0,0,0,34.147,63.928,35.86,35.86,0,0,0,0,29.781",
    transform: "translate(0 7.711)",
    fill: "#ed680f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M34.147,0A35.86,35.86,0,0,0,0,34.146,35.86,35.86,0,0,0,34.147,0",
    transform: "translate(0)",
    fill: "#007b91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M58.715,13.911A11.138,11.138,0,1,1,47.577,2.772,11.138,11.138,0,0,1,58.715,13.911",
    transform: "translate(9.434 0.718)",
    fill: "#8c2984",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M73.273,73.274A76.949,76.949,0,0,1,0,0,76.951,76.951,0,0,1,73.273,73.274",
    transform: "translate(587.228 355.027) rotate(101)",
    fill: "#b5e3ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    d: "M32,0H820a0,0,0,0,1,0,0V768a0,0,0,0,1,0,0H32A32,32,0,0,1,0,736V32A32,32,0,0,1,32,0Z",
    transform: "translate(547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0.75 75)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Log_in_to_your_account_",
    "data-name": "Log in to your account ",
    transform: "translate(956 187)",
    fill: "#778f97",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -90.904,
    y: 0
  }, "Log in to your account ")), /*#__PURE__*/React.createElement("text", {
    id: "Hello_",
    "data-name": "Hello!",
    transform: "translate(956 148)",
    fill: "#334a51",
    fontSize: 39,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.199,
    y: 0
  }, "Hello!")), /*#__PURE__*/React.createElement("g", {
    id: "Component_8_156",
    "data-name": "Component 8 \\u2013 156",
    transform: "translate(739.5 241.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    fill: "none",
    stroke: "#778f97",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 48,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 432,
    height: 47,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Email_ID",
    "data-name": "Email ID",
    transform: "translate(56 30)",
    fill: "#778f97",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email ID")), /*#__PURE__*/React.createElement("g", {
    id: "mail-fill",
    transform: "translate(16 12.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M3,3H21a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3Zm9.06,8.683L5.648,6.238,4.353,7.762l7.72,6.555,7.581-6.56L18.346,6.244l-6.285,5.439Z",
    fill: "#007b91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Component_8_157",
    "data-name": "Component 8 \\u2013 157",
    transform: "translate(740 321.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_84-2",
    "data-name": "Rectangle 84",
    fill: "none",
    stroke: "#778f97",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 48,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 432,
    height: 47,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Password",
    transform: "translate(56 30)",
    fill: "#778f97",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Password")), /*#__PURE__*/React.createElement("g", {
    id: "lock-password-fill",
    transform: "translate(16 12.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M18,8h2a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H6V7A6,6,0,0,1,18,7ZM16,8V7A4,4,0,0,0,8,7V8Zm-5,6v2h2V14ZM7,14v2H9V14Zm8,0v2h2V14Z",
    fill: "#007b91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 -75.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_5_1499",
    "data-name": "Component 5 \\u2013 1499",
    transform: "translate(759 473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M11,16,6.76,11.757l1.414-1.414L11,13.172l5.656-5.657,1.415,1.414Z",
    transform: "translate(-3.417 -2.757)",
    fill: "#007b91",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    fill: "none",
    stroke: "#778f97",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 1,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Remember_me",
    "data-name": "Remember me",
    transform: "translate(785 487)",
    fill: "#334a51",
    fontSize: 12.8,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Remember me")), /*#__PURE__*/React.createElement("text", {
    id: "Forget_Password_",
    "data-name": "Forget Password?",
    transform: "translate(1155 487)",
    fill: "#007b91",
    fontSize: 12.8,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -112.333,
    y: 0
  }, "Forget Password?"))), /*#__PURE__*/React.createElement("g", {
    id: "Component_9_9",
    "data-name": "Component 9 \\u2013 9",
    transform: "translate(908 462.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 96,
    height: 48,
    rx: 8,
    fill: "#007b91"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Log_in",
    "data-name": "Log in",
    transform: "translate(48 29.5)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.208,
    y: 0
  }, "Log in"))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M189.87,189.871C87.148,185.156,4.723,102.722,0,0,102.722,4.723,185.147,87.148,189.87,189.871",
    transform: "translate(617.348 450.414) rotate(101)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M189.873,189.873C87.15,185.158,4.723,102.724,0,0,102.724,4.723,185.15,87.15,189.873,189.873",
    transform: "translate(-73.83 317.585) rotate(-79)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M73.273,73.273A76.949,76.949,0,0,1,0,0,76.951,76.951,0,0,1,73.273,73.273",
    transform: "translate(-37.012 412.973) rotate(-79)",
    fill: "#b5e3ee",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.f029a181db84e3458e8bf5ed7dd3c1f5.svg";
export { ForwardRef as ReactComponent };